import { useEffect, useState, useCallback, CSSProperties } from 'react';
import ReactGifPlayer from "./Player";
import { GifPlayerProps } from "../../types";
import PlayerAssets from '../../PlayerAssets';

type ExtendedGifPlayerProps = GifPlayerProps & {
  containerStyle?: CSSProperties;
};

function GifPlayer(props: ExtendedGifPlayerProps) {
  const { url, style, hash, onComplete, paused, duration, containerStyle } = props;
  const [src, setSrc] = useState<string | null>(null);

  const initPlayer = useCallback(async () => {
    const asset = await PlayerAssets.get(url);
    setSrc(asset.objUrl);
  }, [url]);

  useEffect(() => {
    initPlayer();
  }, [initPlayer, url]);

  useEffect(() => {
    if (paused) return;
    const timeout = setTimeout(() => {
      onComplete(hash);
    }, duration);

    return () => clearTimeout(timeout);
  }, [hash, onComplete, paused, duration]);

  return src ? (
    <div className="gif-player-container" style={containerStyle}>
      <ReactGifPlayer
        gif={src}
        autoplay={!paused}
        style={style}
      />
    </div>
  ) : null;
}

GifPlayer.defaultProps = {
  duration: 1000,
  onComplete: () => {},
};

export default GifPlayer;
